import axios from "axios";
import { getApiBaseUrl } from "./apiBase";

const API = getApiBaseUrl();

const authHeaders = (token) => ({
  Authorization: `Bearer ${token}`,
});

export async function fetchCatalogCustomerOrderDraft(token) {
  const response = await axios.get(`${API}/customer-order-catalog-draft`, {
    headers: authHeaders(token),
  });
  return response.data;
}

export async function saveCatalogCustomerOrderDraft(token, draft) {
  await axios.put(
    `${API}/customer-order-catalog-draft`,
    { draft },
    { headers: authHeaders(token) }
  );
}

export async function deleteCatalogCustomerOrderDraft(token) {
  await axios.delete(`${API}/customer-order-catalog-draft`, {
    headers: authHeaders(token),
  });
}
